import React, { useEffect, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputValidator from './InputValidator';

function formatPhoneNumber(input) {
    const response = InputValidator.allowChars(input, /[0-9]/i);
    if (response.length === 0) {
        return '';
    }
    if (response.length < 3) {
        return `(${response}`;
    } else if (response.length === 3) {
        return `(${response}`;
    } else if (response.length < 6) {
        return `(${response.substring(0, 3)})${response.substring(3, 6)}`;
    } else if (response.length === 6) {
        return `(${response.substring(0, 3)})${response.substring(3, 6)}`;
    } else {
        return `(${response.substring(0, 3)})${response.substring(3, 6)}-${response.substring(6, 10)}`;
    }
}

const PhoneNumberAnswer = (props) => {
    const divRef = useRef(null);
    const q = props.question;
    const id = q.questionID;

    useEffect(() => {
        if (divRef.current) {
            const label = divRef.current.querySelector('label');
            const input = divRef.current.querySelector('input');
            if (label && !label.getAttribute('id')) {
                label.setAttribute('id', q.alias || `q-${id}`);
            }
            if (input && !input?.getAttribute('aria-labelledby')) {
                input.setAttribute('aria-labelledby', q.alias || `q-${id}`);
            }
        }
    });

    return (
        <div ref={divRef}>
            <InputLabel disabled={props.disabled}>
                <p className={props.disabled ? 'questionnaire-invalid disabled' : 'questionnaire-invalid'}>{q.question}</p>
                <TextField
                    type="text"
                    name={`a${id}`}
                    error={props.error}
                    disabled={props.disabled}
                    helperText={props.helperText}
                    onChange={(e) => {
                        props.validateField();
                        const response = formatPhoneNumber(e.target.value);
                        props.responseHandler(id, InputValidator.allowChars(response, /[0-9]/i), e);
                        props.validateField();
                    }}
                    value={formatPhoneNumber(q.response.responseText || '')}
                />
            </InputLabel>
        </div>
    );
};

export default PhoneNumberAnswer;
